/**
 * Fields shown for an OIDC provider using `acquisition_mode: brokered`.
 */

import type { ReactElement } from 'react';
import type { ProviderFormData, SetProviderField } from './providerFormTypes';

interface BrokeredProviderFieldsProps {
  form: ProviderFormData;
  setField: SetProviderField;
  hasClientSecret: boolean;
}

export function BrokeredProviderFields({
  form,
  setField,
  hasClientSecret,
}: BrokeredProviderFieldsProps): ReactElement {
  return (
    <>
      <label className="dialog__field">
        Broker Mechanism
        <select
          value={form.broker_mechanism ?? 'keycloak-broker'}
          onChange={(e) =>
            { setField(
              'broker_mechanism',
              e.target.value as 'keycloak-broker' | 'token-exchange',
            ); }
          }
        >
          <option value="keycloak-broker">Keycloak Broker</option>
          <option value="token-exchange">Token Exchange</option>
        </select>
      </label>
      <label className="dialog__field">
        Broker Alias
        <input
          value={form.broker_alias ?? ''}
          onChange={(e) => { setField('broker_alias', e.target.value || null); }}
        />
      </label>
      <label className="dialog__field">
        Issuer URL
        <input
          value={form.issuer_url ?? ''}
          onChange={(e) => { setField('issuer_url', e.target.value || null); }}
        />
      </label>
      <label className="dialog__field">
        Client ID
        <input
          value={form.client_id ?? ''}
          onChange={(e) => { setField('client_id', e.target.value || null); }}
        />
      </label>
      <label className="dialog__field">
        Client Secret
        <input
          type="password"
          autoComplete="off"
          value={form.client_secret}
          onChange={(e) => { setField('client_secret', e.target.value); }}
        />
        {hasClientSecret && (
          <span className="dialog__help">secret is set — leave blank to keep</span>
        )}
      </label>
      <label className="dialog__field">
        Token Endpoint
        <input
          value={form.token_endpoint ?? ''}
          onChange={(e) => { setField('token_endpoint', e.target.value || null); }}
        />
        <span className="dialog__help">
          token_endpoint required for in-pod refresh of brokered logins
        </span>
      </label>
    </>
  );
}
